export default __webpack_public_path__ + "static/newLogoGreen-7f8c233d819457ea708288c222edc486.png";